import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch, Switch, Route } from 'react-router-dom';

// Material-UI
import { Grid, Button, Divider, GridList, Paper } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';

// Services
import { userCanCreateGroup } from 'services/permissions';
import { getGroups } from 'services/requests';
import useMediaQueries from 'services/media';

// Components
import Spinner from 'components/spinner';
import Error from 'components/error';
import Pagination from 'components/pagination';
import InputText from 'components/input-text';

// Views
import Group from './group';
import CreateGroup from './create-group';

// Assets
import GroupsIcon from 'assets/images/groups.png';

// --------------------------------------------------------------------------------------------------- \\
// -------------------------------------------- ROUTER ----------------------------------------------- \\
// --------------------------------------------------------------------------------------------------- \\

const GroupsRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route exact path={match.path}>
                <Groups />
            </Route>
            <Route path={`${match.path}/:groupId`}>
                <Group />
            </Route>
        </Switch>
    );
};

// --------------------------------------------------------------------------------------------------- \\
// --------------------------------------------- GROUPS ---------------------------------------------- \\
// --------------------------------------------------------------------------------------------------- \\

const Groups = () => {

    const [state, setState] = useState({
        loading: true,
        error: false,
        groups: [],
        offset: 0,
        limit: 15,
        total_count: 0,
        searchName: '',
        openCreate: false,
    });

    function onSearch() {
        setState({ ...state, loading: true, error: false, offset: 0 });
    }

    useEffect(() => {
        if (state.loading) {
            getGroups({
                offset: state.offset,
                limit: state.limit,
                name: state.searchName,
            }).then(res => {
                if (res.status === 200) {
                    setState({
                        ...state,
                        loading: false,
                        offset: res.data.data.offset,
                        limit: res.data.data.limit,
                        total_count: res.data.data.totalCount,
                        groups: res.data.data.userLists,
                    });
                }
                else {
                    console.log(res);
                    setState({ ...state, loading: false, error: true });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    return (
        <>
            {/* -------------------- SUBHEADER -------------------- */}
            <Grid container justify="space-between" alignItems="center" className="subheader">
                Groupes
                {userCanCreateGroup() && (
                    <Button onClick={() => setState({ ...state, openCreate: true })} variant="contained">
                        Créer un groupe
                    </Button>
                )}
            </Grid>
            {/* -------------------- TOOLBAR -------------------- */}
            <Grid container justify="space-between" alignItems="center" className="toolbar">
                <div className="input-group" style={{ width: 300 }}>
                    <div className="input-group-prepend" onClick={onSearch} style={{ cursor: 'pointer' }}>
                        <span className="input-group-text">
                            <SearchIcon />
                        </span>
                    </div>
                    <InputText
                        label="Chercher un groupe..."
                        type="text"
                        value={state.searchName}
                        onChange={e => setState({ ...state, searchName: e.target.value })}
                        onKeyPress={e => e.key === 'Enter' ? onSearch() : null}
                    />
                </div>
                <b>
                    {state.total_count} {state.total_count > 1 ? 'Résultats' : 'Résultat'}
                </b>
            </Grid>
            {/* -------------------- GROUP LIST -------------------- */}
            <div className="main-container">
                <GroupList
                    loading={state.loading}
                    error={state.error}
                    groups={state.groups}
                />
            </div>
            <Divider />
            {/* -------------------- PAGINATION -------------------- */}
            <Grid container justify="flex-end" style={{ padding: 24 }}>
                <Pagination
                    limit={state.limit}
                    total_count={state.total_count}
                    offset={state.offset}
                    setOffset={offset => setState({ ...state, loading: true, offset })}
                />
            </Grid>
            {/* -------------------- CREATE GROUP -------------------- */}
            {state.openCreate && (
                <CreateGroup
                    onClose={() => setState({ ...state, openCreate: false })}
                    refetch={() => setState({ ...state, openCreate: false, loading: true })}
                />
            )}
        </>
    );
};

// --------------------------------------------------------------------------------------------------- \\
// -------------------------------------------- GROUP LIST ------------------------------------------- \\
// --------------------------------------------------------------------------------------------------- \\

const GroupList = ({ loading, error, groups }) => {
    const history = useHistory();
    const match = useRouteMatch();
    const { mediaXS, mediaSM, mediaMD, mediaLG, mediaXL } = useMediaQueries();
    const [cols, setCols] = useState(6);

    useEffect(() => {
        if (mediaXS) setCols(1);
        if (mediaSM) setCols(2);
        if (mediaMD) setCols(4);
        if (mediaLG) setCols(5);
        if (mediaXL) setCols(6);
    }, [mediaXS, mediaSM, mediaMD, mediaLG, mediaXL]);

    if (loading) return <Spinner />;
    if (error) return <Error />;

    return (
        <div className="main-container-item" style={{ paddingBottom: 24 }}>
            <GridList cellHeight={160} cols={cols} style={{ margin: 0 }}>
                {groups.map(group => (
                    <Grid container key={group.id} style={{ padding: 10 }}>
                        <Paper
                            elevation={3}
                            className="paper"
                            onClick={() => history.push(`${match.url}/${group.id}`)}
                        >
                            <img alt="groups-icon" src={GroupsIcon} style={{ height: 40, width: 'auto' }} />
                            <b>{group.name}</b>
                        </Paper>
                    </Grid>
                ))}
            </GridList>
        </div>
    );
};

export default GroupsRouter;
